import * as COM from '../components';
const socialContact = [
  /** ------------------------------ 社交管理
   *  ------------------------------ */
  {
    path: '/social-contact',
    component: COM.Layout,
    redirect: '/social-contact/account-list',
    name: 'potential__socialContact',
    meta: { label: '社交管理' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 账号管理
      {
        path: '/social-contact/account-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.AccountManagementListIndex,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'accountManagementListIndex',
        meta: { label: '账号管理', icon: 'el-icon-document', menuKeyPath: '/social-contact/account-list' }
      },
      {
        path: '/social-contact/account-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/social-contact/account-list/accountDetail',
        name: 'accountManagementLayout',
        meta: {
          label: '账号管理',
          insidePageFrom: 'accountManagementListIndex'
        },
        children: [
          // 账号详情
          {
            path: '/social-contact/account-list/accountDetail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AccountDetail
            },
            name: 'accountDetail',
            meta: {
              label: '账号详情',
              icon: 'el-icon-document',
              menuKeyPath: '/social-contact/account-list',
              authKey: 'accountManagementListIndex'
            }
          },
        ]
      },
      // 违规管理
      {
        path: '/social-contact/accusation',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.AccusationManagementListIndex,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'accusationManagementListIndex',
        meta: { label: '违规管理', icon: 'el-icon-document', menuKeyPath: '/social-contact/accusation' }
      },
      {
        path: '/social-contact/accusation',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/social-contact/accusation',
        name: 'accusationManagementLayout',
        meta: {
          label: '违规管理',
          insidePageFrom: 'accusationManagementListIndex'
        },
        children: [
          // 账号举报
          {
            path: '/social-contact/accusation/accountAccusationDetail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AccountAccusationDetail
            },
            name: 'accountAccusationDetail',
            meta: {
              label: '举报详情',
              icon: 'el-icon-document',
              menuKeyPath: '/social-contact/accusation',
              authKey: 'accusationManagementListIndex'
            }
          },
          // 动态举报
          {
            path: '/social-contact/accusation/dynamicAccusationDetail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.DynamicAccusationDetail
            },
            name: 'dynamicAccusationDetail',
            meta: {
              label: '举报详情',
              icon: 'el-icon-document',
              menuKeyPath: '/social-contact/accusation',
              authKey: 'accusationManagementListIndex'
            }
          },
          // 内容申诉
          {
            path: '/social-contact/accusation/contentAppealDetail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.ContentAppealDetail
            },
            name: 'contentAppealDetail',
            meta: {
              label: '内容申诉详情',
              icon: 'el-icon-document',
              menuKeyPath: '/social-contact/accusation',
              authKey: 'accusationManagementListIndex'
            }
          },
          // 账号申诉
          {
            path: '/social-contact/accusation/accountAppealDetail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AccountAppealDetail
            },
            name: 'accountAppealDetail',
            meta: {
              label: '账号申诉详情',
              icon: 'el-icon-document',
              menuKeyPath: '/social-contact/accusation',
              authKey: 'accusationManagementListIndex'
            }
          },
        ]
      },
      // 动态管理
      {
        path: '/social-contact/dynamic-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.DynamicManagement,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'dynamicManagement',
        meta: { label: '动态管理', icon: 'el-icon-document', menuKeyPath: '/social-contact/dynamic-list' }
      },
      {
        path: '/social-contact/dynamic-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/social-contact/dynamic-list',
        name: 'dynamicManagementLayout',
        meta: {
          label: '动态管理',
          insidePageFrom: 'dynamicManagement'
        },
        children: [
          // 动态详情
          {
            path: '/social-contact/dynamic-list/dynamicDetail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.DynamicDetail
            },
            name: 'dynamicDetail',
            meta: {
              label: '动态详情',
              icon: 'el-icon-document',
              menuKeyPath: '/social-contact/dynamic-list',
              authKey: 'dynamicManagement'
            }
          },
          // 编辑动态
          {
            path: '/social-contact/dynamic-list/addDynamic',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AddDynamic
            },
            name: 'addDynamic',
            meta: {
              label: '编辑动态',
              icon: 'el-icon-document',
              menuKeyPath: '/social-contact/dynamic-list',
              authKey: '#dynamicManagement.addDynamic'
            }
          },
        ]
      },
      // 达人后台
      {
        path: '/social-contact/talent-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.TalentManagement,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'talentManagement',
        meta: { label: '达人后台', icon: 'el-icon-document', menuKeyPath: '/social-contact/talent-list' }
      },
      {
        path: '/social-contact/talent-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/social-contact/talent-list',
        name: 'talentManagementLayout',
        meta: {
          label: '达人后台',
          insidePageFrom: 'talentManagement'
        },
        children: [
          // 动态详情
          {
            path: '/social-contact/talent-list/talentDetail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.TalentDetail
            },
            name: 'talentDetail',
            meta: {
              label: '动态详情',
              icon: 'el-icon-document',
              menuKeyPath: '/social-contact/talent-list',
              authKey: 'talentManagement'
            }
          },
          // 发布动态
          {
            path: '/social-contact/talent-list/addTalent',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AddTalent
            },
            name: 'addTalent',
            meta: {
              label: '发布动态',
              icon: 'el-icon-document',
              menuKeyPath: '/social-contact/talent-list',
              authKey: '#talentManagement.addTalent'
            }
          },
        ]
      },
      // 标签管理
      {
        path: '/social-contact/label-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.LabelManagement,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'labelManagement',
        meta: { label: '标签管理', icon: 'el-icon-document', menuKeyPath: '/social-contact/label-list' }
      },
      // 话题管理
      {
        path: '/social-contact/topic-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.TopicManagement,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'topicManagement',
        meta: { label: '话题管理', icon: 'el-icon-document', menuKeyPath: '/social-contact/topic-list' }
      }
    ]
  }
];

export default socialContact;
